<template>
    <div id="sponsors">
        <section class="gh-section">
      <div class="container organiser-container">
        <el-row :gutter="30" class="gh-sponsor-wrapper">
          <el-col class="gh-left-sponsor" :xs="24" :sm="12">
            <p class="section-heading gh-heading gh-blue">ORGANISER</p>
            <h3 class="heading-2 gh-blue">Mental Health Academy</h3>
            <p class="heading-3">
              Mental Health Academy (MHA) is a global provider of continuing professional development (CPD) for the mental health industry. MHA members enjoy access to over {{ LaraVue && LaraVue.figure.totalHours }} hours of CPD online, conveniently accessible from anywhere, on-demand, 24/7.
            </p>
            <a href="/" target="_blank" class="">
              <img class="pb-2 logo-image" src="/images/suicidePreventionSummit/MHA-Logo-colour.svg"
                  alt="Mental Health Academy Logo"/>
            </a>
          </el-col>
          <el-col class="gh-right-sponsor" :xs="24" :sm="12">
            <p class="section-heading gh-heading gh-blue">CO-HOST</p>
            <h3 class="heading-2 gh-blue">British Psychological Society</h3>
            <p class="heading-3">
              The British Psychological Society is a registered charity which acts as the representative body for psychology and psychologists in the UK, and is responsible for the promotion of excellence and ethical practice in the science, education, and application of the discipline.
            </p>
           <a data-v-2d05d9ea="" href="//www.bps.org.uk" target="_blank"><img data-v-2d05d9ea="" src="/images/suicidePreventionSummit/logos/BPS_Logo_color.png" alt="BPS LOGO" class="logo-image logo-image-other"></a>
          </el-col>
          <!-- <el-col class="gh-right-sponsor" :xs="24" :sm="12">
            <div class="gh-partners">
              <p class="section-heading gh-heading gh-blue">CO-HOSTS</p>

            <el-row :gutter="40">
              <el-col class="partnerbox" :span="12" v-for="(partner, index) in eventPartners" :key="index">
                <a :href="partner.url" class="" target="_blank">
                  <img :class="'partner-logo-image ' + (partner.styleClass ? partner.styleClass : '')"
                      :src="partner.logo" alt=""/>
                </a>
              </el-col>
            </el-row>
            </div>
          </el-col> -->
        </el-row>
      </div>
    </section>
    </div>
</template>

<script>
    export default {
      computed: {
        LaraVue() {
          return LaraVue
        },

        sponsors() {
          return this.$store.state.event.eventSponsors
        },

        // eventPartners() {
        //   return [
            // {
            //   logo: "/images/suicidePreventionSummit/logos/ACA Logo.png",
            //   url: "//www.counseling.org/",
            //   name: "American Counseling Association",
            //   styleClass: "gh-logo-img-extra2"
            // },
            // {
            //   logo: "/images/suicidePreventionSummit/logos/AAS-LOGO.png",
            //   url: "//suicidology.org",
            //   name: "American Association of Suicidology ",
            // },
            // {
            //   logo: "/images/suicidePreventionSummit/NBCCFlogo.png",
            //   url: "https://www.nbccf.org/",
            //   name: "NBCC Foundation",
            // },
            // {
            //   logo: "/images/suicidePreventionSummit/ccpa-logo.png",
            //   url: "https://www.ccpa-accp.ca/",
            //   name: "CCPA",
            // }
        //   ]
        // }
      },
    }
</script>
<style lang="scss" scoped>
.organiser-container {
  @media (max-width: 678px) {
    padding-top: 0;
    padding-bottom: 0;
  }
}

.partner-logo-image {
  max-height: 75px;

  @media(max-width:840px) {
    max-width: 125px;
  }
  @media(max-width:767px) {
    max-width: 220px;
  }
  @media(max-width:480px) {
    max-width: 180px;
  }
}

.partner-logo-image-extra {
  max-height: 55px;
  @media(max-height:480px) {
    max-height: 50px;
  }
}

.gh-sponsor-wrapper {
  @media (max-width: 1023px) {
    height: 430px;
  }
  @media (max-width: 767px) {
    height: unset;
  }
  @media (min-width: 768px) {
    display: flex;
  }

}
.partnerbox {
  display: flex;
  justify-content: space-between;
  margin-bottom: 3rem;
  align-items: center;
  height: 75px;
  @media(max-width:767px) {
    justify-content: center;
  }
}
.gh-left-sponsor {
  @media (min-width: 768px) {
    // border-right: 1px solid #f34235;
    padding-right: 60px !important;
    .heading-3 {
      margin-bottom: 3rem;
    }

  }
}

.gh-right-sponsor {
  padding-left: 3rem;

  @media (max-width: 767px) {
    margin-top: 3rem;
  }
}

.sponsor-link {
  background-color: white;
  width: 100%;
  @media screen and (max-width: 678px) {
    width: 210px;
  }
}

.gh-heading {
  font-weight: 600;
  font-size: 1.4rem;
  margin-bottom: 1rem;
  color: #374785;
}

.gh-partners {
  padding-left: 2rem;
}

.heading-2 {
  font-size: 2.4rem;
  font-weight: 600;
  margin-bottom: 20px;
}

.heading-3 {
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.4;
}

.logo-image {
  width: 242px;
  max-height: 80px;
  margin-top: 30px;
}

.heading-4 {
  font-size: 2.5rem;
  font-weight: 600;
  @media (max-width: 767px) {
    font-size: 1.7rem;
  }
}

.heading-5 {
  font-size: 1rem;
  font-weight: 600;
  @media (max-width: 767px) {
    font-size: 0.8rem;
  }
}

.l-major-sponsors {
  background: #f0f6f8;
  text-align: center;
  a {
    display: inline-block;
  }
}

@media screen and (min-width: 1024px) {
  .sponsors-list {
    width: 79%;
    margin: 0 auto;
  }
}

.gh-sponsor-text {
  color: #474f59;
  font-size: 1.4rem;
  line-height: 1.2;
  margin: 10px 0 40px;
  @media (min-width: 1366px) {
    margin-right: 10%;
    margin-left: 10%;
  }
}

@media (max-width: 480px) {
  .gh-partners {
    padding-left: 0;
  }
}
</style>
